module.exports = __webpack_public_path__ + "img/04.63893d67.png";